import React from 'react';

const About: React.FC = () => {
    return (
        <div className="about">
            <h1>About</h1>
            
            <div className="director-info">
                <h2>👨✈️ Director</h2>
                <h3>Lt. Col. Uma Shankar (Retd)</h3>
                <p><strong>Proprietor</strong><br />Uma Shankar Security Agency</p>
                
                <p>Lt Col Uma Shankar (Retd) brings with him an illustrious 39 years of distinguished service in the Indian Army, where he served in the Infantry and held key operational, administrative, and leadership roles, including the command of an Infantry Battalion. His experience in strategic planning, security operations, threat assessment, and personnel training forms the strong professional foundation of US Security Agency. Having led teams in high-pressure environments, he embodies unmatched discipline, vigilance, and operational excellence. His deep commitment to integrity, precision, and teamwork shapes the organization's culture and service philosophy. Under his dynamic leadership, the company has grown into a trusted name in the field of security and manpower management, known for its reliability, professionalism, and high standards of service.</p>
            </div>

            <div className="professional-background">
                <h2>🎖️ Professional Background</h2>
                <p>After a distinguished military career, he transitioned seamlessly into the corporate world and has spent the past 10 years successfully managing and expanding security and manpower operations across multiple sectors — including public and private establishments, corporate offices, residential complexes, and event security.</p>
                <p>Lt Col. Uma Shankar continues to inspire his teams through his commitment to discipline, accountability, and service excellence — ensuring every client experiences the highest standard of safety and operational efficiency.</p>
            </div>
        </div>
    );
};

export default About;